import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user_service';

export const accountRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
    const userService = inject(UserService);
    const router = inject(Router);

    const userId = route.params['userId'];
    
    if (!userId || userId.length === 0) {
        return Promise.resolve(router.createUrlTree(['/']));
    }

    return userService.getProfile().then((user) => {
        if (user && user.id.toString() === userId) {
            return true;
        } else {
            return router.createUrlTree(['/']);
        }
    }).catch(() => {
        return router.createUrlTree(['/']);
    });
};